import { formatCampaignPeriodLabel as formatLocalizedCampaignPeriodLabel, formatDate, formatStrategyLabel } from './optionsHistoryUtils';

export const sortCampaignOperations = (detail) => {
  return [...(detail?.operations || [])].sort((a, b) => new Date(a.opened_at || 0).getTime() - new Date(b.opened_at || 0).getTime());
};

export const formatCampaignPeriodLabel = (isoString, language = 'en') => formatLocalizedCampaignPeriodLabel(isoString, language);

export const formatRollTypeLabel = (type) => {
  if (!type) return 'Roll';
  return String(type)
    .toLowerCase()
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export const getRollTransition = (detail, sourceOperationId, targetOperationId, language = 'en') => {
  const links = (detail?.roll_links || []).filter((link) => link.source_operation_id === sourceOperationId && link.target_operation_id === targetOperationId);
  if (!links.length) return null;

  const sortedLinks = [...links].sort((a, b) => new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime());
  const rollTypes = Array.from(new Set(sortedLinks.flatMap((link) => link.roll_types || [])));

  return {
    createdAt: sortedLinks[0]?.created_at || null,
    createdAtLabel: sortedLinks[0]?.created_at ? formatDate(sortedLinks[0].created_at, language) : '—',
    rollTypes,
    rollTypeLabel: rollTypes.map(formatRollTypeLabel).join(' + '),
  };
};

export const canShowCampaignEquationSummary = (detail) => {
  return Boolean(detail?.campaign?.roll_link_count) && sortCampaignOperations(detail).length === 2;
};

export const getCampaignEquationSummary = (detail) => {
  const operations = sortCampaignOperations(detail);
  if (!canShowCampaignEquationSummary(detail)) return null;
  return {
    previousOperation: operations[0],
    currentOperation: operations[1],
    campaign: detail.campaign,
  };
};

export const buildOperationHeading = (operation) => {
  return `${formatCampaignPeriodLabel(operation?.expiration)} — ${formatStrategyLabel(operation?.strategy_label)}`;
};